import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

import auth from "./modules/auth";
import clients from "./modules/clients";
import attributes from "./modules/attributes";
import parkings from "./modules/parkings";
import spots from "./modules/spots";
import groups from "./modules/groups";
import errorManagement from "./modules/errorManagement";
import adminAccess from "./modules/adminAccess";
Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [createPersistedState({ key: "dynapark-admin-app" })],
  state: {},
  mutations: {},
  actions: {},
  modules: {
    auth,
    clients,
    attributes,
    parkings,
    spots,
    groups,
    errorManagement,
    adminAccess,
  },
});
